import { render } from "./ArticleProduct.vue?vue&type=template&id=1f54c63e"
import script from "./ArticleProduct.vue?vue&type=script&lang=js"
export * from "./ArticleProduct.vue?vue&type=script&lang=js"

import "./ArticleProduct.vue?vue&type=style&index=0&id=1f54c63e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__